/**
 * Google Analytics utility functions
 * Only tracks events if GA_MEASUREMENT_ID is set
 */

// Check if Google Analytics is enabled
const isAnalyticsEnabled = () => {
  return process.env.REACT_APP_GA_MEASUREMENT_ID && 
         process.env.REACT_APP_GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX' &&
         typeof window !== 'undefined' && 
         typeof window.gtag !== 'undefined';
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional event parameters
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (!isAnalyticsEnabled()) {
    return;
  }
  
  try {
    window.gtag('event', eventName, eventParams);
  } catch (error) {
    console.error('Analytics tracking error:', error);
  }
};

/**
 * Track user signup
 */
export const trackSignup = () => {
  trackEvent('signup', {
    event_category: 'engagement',
    event_label: 'user_registration'
  });
};

/**
 * Track user login
 */
export const trackLogin = () => {
  trackEvent('login', {
    event_category: 'engagement',
    event_label: 'user_login'
  });
};

/**
 * Track league creation
 * @param {string} draftType - Type of draft (SNAKE, SALARY_CAP, etc.)
 * @param {number} teamCount - Number of teams
 */
export const trackLeagueCreation = (draftType, teamCount) => {
  trackEvent('create_league', {
    event_category: 'league',
    event_label: 'league_created',
    draft_type: draftType,
    team_count: teamCount
  });
};

/**
 * Track league join
 * @param {boolean} isPublic - Whether it's a public league
 */
export const trackLeagueJoin = (isPublic = false) => {
  trackEvent('join_league', {
    event_category: 'league',
    event_label: 'league_joined',
    league_type: isPublic ? 'public' : 'private'
  });
};

/**
 * Track draft start
 * @param {string} draftType - Type of draft
 */
export const trackDraftStart = (draftType) => {
  trackEvent('draft_start', {
    event_category: 'draft',
    event_label: 'draft_started',
    draft_type: draftType
  });
};

/**
 * Track draft completion
 * @param {string} draftType - Type of draft
 */
export const trackDraftComplete = (draftType) => {
  trackEvent('draft_complete', {
    event_category: 'draft',
    event_label: 'draft_completed',
    draft_type: draftType
  });
};

/**
 * Track page view
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (!isAnalyticsEnabled()) {
    return;
  }
  
  try {
    window.gtag('config', process.env.REACT_APP_GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
  } catch (error) {
    console.error('Analytics page view error:', error);
  }
};
